import checkHolidays from "../../table-hours/checkHolidays";

export function bannerHours(){
  var currentday = new Date();//"2022-12-25 12:00:00"
  if(document.querySelector('.banner__hours')){
    let dayCols = document.querySelectorAll('.js-banner__hours__days')
    const date = new Date(currentday);
    const dayNumber = date.getDay();
    const holidays = checkHolidays(date)

    function getLocale() {
      const raw = document.documentElement.lang || 'da';
      return raw.toLowerCase().startsWith('en') ? 'en-US' : raw;
    }

    function formatLocalDate(date) {
      return new Intl.DateTimeFormat(getLocale(), { day: 'numeric', month: 'short', year: 'numeric' }).format(date);
    }

    function localWeekdayName(date) {
      return new Intl.DateTimeFormat(getLocale(), { weekday: 'long' }).format(date);
    }

    function readI18n(col) {
      const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
      const en = { closed: 'Closed', open: 'Open', opensAt: 'Opens at', opensOn: 'Opens', busyUntil: 'Busy until', closedHolidayOpensAgain: 'Closed due to holiday, opens again', closedOpensAgain: 'Closed, opens again' };
      const da = { closed: 'Lukket', open: 'Åben', opensAt: 'Åbner kl.', opensOn: 'Åbner', busyUntil: 'Travlt indtil kl.', closedHolidayOpensAgain: 'Lukket pga. helligdag, åbner igen', closedOpensAgain: 'Lukket, åbner igen' };
      const i18n = isEnglish ? { ...en } : {
        closed: col.getAttribute('data-i18n-closed') || da.closed,
        open: col.getAttribute('data-i18n-open') || da.open,
        opensAt: col.getAttribute('data-i18n-opens-at') || da.opensAt,
        opensOn: col.getAttribute('data-i18n-opens-on') || da.opensOn,
        busyUntil: col.getAttribute('data-i18n-busy-until') || da.busyUntil,
        closedHolidayOpensAgain: col.getAttribute('data-i18n-closed-holiday-opens-again') || da.closedHolidayOpensAgain,
        closedOpensAgain: col.getAttribute('data-i18n-closed-opens-again') || da.closedOpensAgain
      };
      i18n.atPrefix = i18n.opensAt.replace(new RegExp('^' + i18n.opensOn.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*', 'i'), '').trim();
      return i18n;
    }

    //function that returns true or false to whether current day is within the custom closing period. Takes two dates as argument in format YYYY-MM-DD
    function checkCustomCloseDays(start, end){
      let startDay = new Date(`${start}T00:00:01`)
      let endDay = new Date(`${end}T23:59:59`)
      let today = new Date();
      let startTimestamp = startDay.getTime()
      let endTimestamp = endDay.getTime()
      let currentTimestamp = today.getTime()
      if (currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp){ return true
      } else { return false }
    }

    //function that sets the strings for custom closed days
    function customCloseDays(day, start, end, indicator, i18n){
      let endDate = new Date(end);
      let startDate = new Date(start);
      let spans = day.children;

      let endDateFormatted = formatLocalDate(endDate);
      let startDateFormatted = formatLocalDate(startDate);

      spans[0].textContent = i18n.closed
      spans[0].classList.add('closed');
      if(spans[1]){
        for(let i = 1; i < spans.length; i++){
          spans[i].classList.add('hidden')
        }
      }
      indicator.classList.add('hidden')
      day.parentElement.querySelector('.js-info-close-dates').classList.remove('hidden');
      //check if only closed on one day
      if(start == end || !end){
        let spans = day.parentElement.querySelector('.js-info-close-dates').children
        spans[1].classList.add('hidden')
        spans[2].classList.add('hidden')
      }
      day.parentElement.querySelector('.js-close-start').textContent = startDateFormatted
      day.parentElement.querySelector('.js-close-end').textContent = endDateFormatted
    }

    //function that returns next open day and time as a string. Returns false if next open day is a custom closed day
    function FindNextOpenDay(day, dayNumber, closedDay, i18n){
      let nextOpenDay;
      let nextOpenDayNumber;
      let i = dayNumber;
      let counter = 0
      let nextOpenDayDate = false
      let today = new Date(currentday)

      //finds next open day
      i++
      if(i > 6){i = 0}
      //run loop while day is holiday or day contains 'closed' class (and counter is less than 7, to prevent infinite loop)
      while((checkHolidays(today).isHoliday || day.parentNode.querySelector(`.js-day-${i}`).getElementsByTagName('span')[0].classList.contains('closed')) && counter <= 7){
        today.setDate(today.getDate() + 1);
        i++;
        counter++;
        if(i > 6){
          i = 0
        }
      }

      //check if next open day is custom close day
      if(counter == 0){
        today.setDate(today.getDate() + 1);
        nextOpenDayDate = today.toISOString().substring(0, 10);
      } else {
        nextOpenDayDate = today.toISOString().substring(0, 10);
      }
      let isClosedDay = nextOpenDayDate == closedDay


      //construct strings with default next open day and time

      nextOpenDay = day.parentNode.querySelector(`.js-day-${i}`)
      nextOpenDayNumber = parseInt(nextOpenDay.classList[1].replace('js-day-', ''))

      //if no open times are set, return blank string (prevent infinite loop)
      if(counter > 6){ return ' '}

      //if next open day is a custom closed day
      if(isClosedDay){
        return false
      }

      //default, return next open day and time
      const weekdayName = localWeekdayName(today);
      const openTime = nextOpenDay.getElementsByTagName('span')[0].textContent;
      return `${i18n.opensOn} ${weekdayName} ${i18n.atPrefix} ${openTime}`
    }
    
    dayCols.forEach((col) => {
      const disableHolidays = col.classList.contains('js-disable-holidays');
      const i18n = readI18n(col);
      let days = col.querySelectorAll('.info-time');

      days.forEach(day => {
        if(day.classList.contains(`js-day-${dayNumber}`)){
          day.classList.remove('hidden')

          if(day.getElementsByTagName('span')[0].classList){

            let statusIndicatorText = day.parentElement.querySelector('.info-status')
            let statusIndicator = day.parentElement.querySelector('.info-status-indicator')

            let currentDayOpenTime = day.querySelector('.open') ? parseFloat(day.querySelector('.open').textContent.replace(":",".")) : false;
            let currentDayClosingTime = day.querySelector('.close') ? parseFloat(day.querySelector('.close').textContent.replace(":",".")) : false;
            let currentDayOpenTimeTwo = day.querySelector('.openTwo') ? parseFloat(day.querySelector('.openTwo').textContent.replace(":",".")) : false;
            let currentDayClosingTimeTwo = day.querySelector('.closeTwo') ? parseFloat(day.querySelector('.closeTwo').textContent.replace(":",".")) : false;
            let busyTimeStart = day.querySelector('.js-busy-start') ? parseFloat(day.querySelector('.js-busy-start').textContent.replace(":",".")) : false;
            let busyTimeEnd = day.querySelector('.js-busy-end') ? parseFloat(day.querySelector('.js-busy-end').textContent.replace(":",".")) : false;

            let closedDayStart = day.parentElement.querySelector('.js-close-start') ? day.parentElement.querySelector('.js-close-start').textContent.replace(":",".") : false
            let closedDayEnd = day.parentElement.querySelector('.js-close-end') ? day.parentElement.querySelector('.js-close-end').textContent.replace(":",".") : false

            let currentTime = parseFloat(`${date.getHours()}.${date.getMinutes()}`)

            //check if within custom close days
            if(closedDayStart && checkCustomCloseDays(closedDayStart, closedDayEnd)){
              customCloseDays(day, closedDayStart, closedDayEnd, statusIndicatorText, i18n)
            }

            //check if closed
            else if(day.getElementsByTagName('span')[0].classList.contains('closed')){
              var NextOpenDay = FindNextOpenDay(day, dayNumber, closedDayStart, i18n)
              statusIndicator.classList.add('hidden')
              if(!NextOpenDay){ customCloseDays(day, closedDayStart, closedDayEnd, statusIndicatorText, i18n) }
              else {
                statusIndicatorText.textContent = NextOpenDay;
              }
              if(NextOpenDay == " ") {
                statusIndicatorText.classList.add('hidden')
                busyTimeEnd.classList.add('hidden')
              }
            }
            //check if holiday
            else if(holidays.isHoliday && !disableHolidays){
              let spans = day.children;
              spans[1].classList.add('closed');
              spans[1].textContent = i18n.closedHolidayOpensAgain

              if(spans[1]){
                spans[0].classList.add('hidden')
                spans[2].classList.add('hidden')
              }
              if(currentDayOpenTimeTwo){
                spans[3].classList.add('hidden')
                spans[4].classList.add('hidden')
                spans[5].classList.add('hidden')
                spans[6].classList.add('hidden')
              }

              statusIndicator.classList.add('hidden')
              if(FindNextOpenDay(day, dayNumber, closedDayStart, i18n)){
                statusIndicatorText.textContent = FindNextOpenDay(day, dayNumber, closedDayStart, i18n)
              } else { FindNextOpenDay(day, dayNumber, closedDayStart, i18n) }
            }

            //check if current time is within first opening hours
            else if(currentDayOpenTime && (currentTime > currentDayOpenTime && currentTime < currentDayClosingTime)){

              //check if within busy time
              if(busyTimeStart && (currentTime > busyTimeStart && currentTime < busyTimeEnd)){
                statusIndicator.classList.add('busy')
                statusIndicatorText.classList.add('busy')
                day.parentElement.querySelector('.info-status-text').textContent = `${i18n.open},`
                day.parentElement.querySelector('.info-status-busy').textContent = ` ${i18n.busyUntil} ${busyTimeEnd}`
              } else {

                //if open, outside busy time
                if(busyTimeStart){
                  day.parentElement.querySelector('.info-status-busy').classList.add('hidden')
                  //day.parentElement.querySelector('.js-busy-end').classList.add('hidden')
                  statusIndicator.classList.add('open')

                //if no busy time set
                } else {
                  day.parentElement.querySelector('.info-status-busy').classList.add('hidden')
                }
                statusIndicator.classList.add('open')
                statusIndicatorText.classList.add('open')
              }
            }

            // check if current time is within second opening hours
            else if(currentDayOpenTimeTwo && (currentTime > currentDayOpenTimeTwo && currentTime < currentDayClosingTimeTwo)){
              //check if within busy time
              if(busyTimeStart && (currentTime > busyTimeStart && currentTime < busyTimeEnd)){
                statusIndicator.classList.add('busy')
                statusIndicatorText.classList.add('busy')
                day.parentElement.querySelector('.info-status-text').textContent = `${i18n.open},`
                day.parentElement.querySelector('.info-status-busy').textContent = ` ${i18n.busyUntil} ${busyTimeEnd}`
              } else {

                //if open, outside busy time
                if(busyTimeStart){
                  day.parentElement.querySelector('.info-status-busy').classList.add('hidden')
                  //day.parentElement.querySelector('.js-busy-end').classList.add('hidden')
                  statusIndicator.classList.add('open')

                //if no busy time set
                } else {
                  day.parentElement.querySelector('.info-status-busy').classList.add('hidden')
                }
                statusIndicator.classList.add('open')
                statusIndicatorText.classList.add('open')
              }
            }

            //check if before opening hours (opens later today)
            else if (currentDayOpenTime && (currentTime < currentDayOpenTime)) {
              statusIndicator.classList.add('closed')
              day.parentElement.querySelector('.info-status-text').textContent = `${i18n.closed} `
              day.parentElement.querySelector('.info-status-busy').textContent = `| ${i18n.opensAt} ${day.querySelector('.open').textContent}`
              day.parentElement.querySelector('.info-status-text').classList.add('closed')
              day.parentElement.querySelector('.info-status-busy').classList.add('closed')
              //day.parentElement.querySelector('.js-busy-end').classList.add('hidden')
            }
            //check if before  second opening hours (opens later today)
            else if (currentDayOpenTimeTwo && (currentTime < currentDayOpenTimeTwo)) {
              statusIndicator.classList.add('closed')
              day.parentElement.querySelector('.info-status-text').textContent = `${i18n.closed} `
              day.parentElement.querySelector('.info-status-busy').textContent = `| ${i18n.opensAt} ${day.querySelector('.openTwo').textContent}`
              day.parentElement.querySelector('.info-status-text').classList.add('closed')
              day.parentElement.querySelector('.info-status-busy').classList.add('closed')
              //day.parentElement.querySelector('.js-busy-end').classList.add('hidden')
            }
            // else, closed
            else {

              let spans = day.children;
              let nextOpenDay = FindNextOpenDay(day, dayNumber, closedDayStart, i18n)
              if(nextOpenDay){
                spans[1].classList.add('closed');
                spans[1].textContent = i18n.closedOpensAgain
                statusIndicatorText.textContent = nextOpenDay;
                if(spans[1]){
                  spans[0].classList.add('hidden')
                  spans[2].classList.add('hidden')
                }
                if(currentDayOpenTimeTwo){
                  spans[3].classList.add('hidden')
                  spans[4].classList.add('hidden')
                  spans[5].classList.add('hidden')
                  spans[6].classList.add('hidden')
                }
              } else {
                customCloseDays(day, closedDayStart, closedDayEnd, statusIndicatorText, i18n)
              }

            }

          }
        }
      })

    })

  }
}

export default bannerHours
